/* global REACT_APP_API_BASE_URL:true */
import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";

export async function getVehicles(_, params) {
  const urlParams = new URLSearchParams(window.location.search);
  const entityId = urlParams.get("entityId");
  const sorting = params.sorting ? params.sorting.split(":") : "";
  const filtering = params.filtering ? params.filters : null;
  const { SkipCount, MaxResultCount } = paginationParams(params.current, params.pageSize);
  const paramsPayload = {
    SkipCount,
    MaxResultCount,
  };
  if (sorting) {
    const [column, order] = sorting;
    paramsPayload.column = column;
    paramsPayload.order = order;
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount += 1;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.FilterText = params.searchValue.toLowerCase().trim();
  }
  let result;
  if (entityId) {
    result = await request(`${REACT_APP_API_BASE_URL}/api/Entities/Vehicles?id=${entityId}`, {
      params: { paramsPayload },
    });
  } else {
    // result = request(`${REACT_APP_API_BASE_URL}/api/Dealer/Vehicles`, {
    result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles`, {
      params: paramsPayload,
    });
  }

  return result;
}

export async function createVehicle(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles`, {
    method: "POST",
    data: payload,
  });

  return result?.data;
}

export async function createAdminVehicle(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin`, {
    method: "POST",
    data: payload,
  });

  return result?.data;
}

export async function editVehicle(data, vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/${vehicleId}`, {
    method: "PUT",
    data,
  });

  return result?.data;
}

export async function editAdminVehicle(data, vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin/${vehicleId}`, {
    method: "PUT",
    data,
  });

  return result?.data;
}

export async function deleteVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/${vehicleId}`, {
    method: "DELETE",
  });

  if (result) {
    const { response } = result;
    return response && response.ok && response.status === 204;
  }

  return result;
}

export async function adminDeleteVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin/${vehicleId}`, {
    method: "DELETE",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}

export async function uploadBolMedia(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol-media`, {
    method: "POST",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result;
}

export async function getVINData(vin, options = {}) {
  const params = {
    vin,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/decoder`, {
    method: "GET",
    params,
    ...options,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getVinDataByVehicle(make, model, options = {}) {
  const params = {
    make,
    model,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/decoder/by-vehicle`, {
    method: "GET",
    params,
    ...options,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getTransporterVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/transporter/${vehicleId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getDealerVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/dealer/${vehicleId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getAdminSingleVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin/${vehicleId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getBOL(vehicleId) {
  const params = {
    vehicleId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function deleteBOLMedia(data) {
  const params = {
    ids: data,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol-media`, {
    method: "DELETE",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getBOLDocuments(vehicleId) {
  const params = {
    vehicleId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol-group`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getBOLHistory(vin) {
  const params = {
    vin,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol/historical`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getBOLHistoryUrl(id) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol/historical/url/${id}`, {
    method: "GET",
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getVehicleBreakpoints({ vehicleType, curbWeight }) {
  const params = {
    vehicleType,
    curbWeight,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicle-breakpoints`, {
    method: "GET",
    params,
  });
  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getVehicleBreakpointsByName(names) {
  const params = {
    names,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicle-breakpoints/by-names`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getVehicleMakes({ page = 1, pageSize = 10, filter = "", year }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    SkipCount,
    MaxResultCount,
    Filter: filter || undefined,
    Year: year || undefined,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/vehicle-lookups/makes`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getVehicleModelsByMake({ page = 1, pageSize = 10, filter = "", make, year }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    SkipCount,
    MaxResultCount,
    Make: make,
    Filter: filter || undefined,
    Year: year || undefined,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/vehicle-lookups/models`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getVehicleTrimsByMakeModel({ page = 1, pageSize = 10, filter = "", make, model, year }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    SkipCount,
    MaxResultCount,
    Make: make,
    Model: model,
    Filter: filter || undefined,
    Year: year || undefined,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/vehicle-lookups/trims`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getVehicleSizesByYearMakeModelTrim({ year, make, model, trim }) {
  const params = {
    year,
    make,
    model,
    trim,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/decoder/by-vehicle`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
